export const TILE_COLS = 55;
export const TILE_ROWS = 29;

export const SOLUTION_CENTER_MAP_DATA: string[] = [
    '1111111111111111111111111111111111111111111111111111111',
    '1010000022200000000000000000100000000000012200000002221',
    '1010002022200100000000000000100000000000010000000002221',
    '1010000022200000000000000002120000000000010000000002221',
    '1000000022200000022220000002120222222200012222220002221',
    '1000000022200000000000000002120000000000012222220002221',
    '1000000022200000000000000000120000000000012222220002221',
    '1000000022200000000000000000100000000000010000000002221',
    '1111100000000000000000000000100000000000010000000002221',
    '1111100000000000000000000000100000000000010000000022221',
    '1111111111111111111111110001111111111000111000111122221',
    '1000000000022222002222200000000000000000000000000022221',
    '1011100222022222002222200000000011100000000000000022221',
    '1011100222022222000000000000000011100000000000000000000',
    '1011100222022222000000000000000011100000000000000000000',
    '1000000000000000000000000000000000000000000000000000000',
    '1000000000000000000000000000000000000000000000000000000',
    '1000000000000000000000000000000000000000000000000000001',
    '1000000000000000000000000000000000000000000000000000001',
    '1000000000000000000000000000000000000000000110000000001',
    '1022200000002222222222000000000000000000011111111000111',
    '1222222000022222222222200002222222200000111111100000221',
    '1222222000022222222222200002222222200000111111100000221',
    '1022200000000222020222000000022222200000001110100000221',
    '1000000000000000020000000000000022200000001110100000221',
    '1000000000000000020000000000000022200000000000100000001',
    '1000000000000000020000000000000022200000000000100000001',
    '1000000000000000020000000000000020000000000000101100221',
    '1111111111111111111111111111111111111111111111111111111',
];

export const RESEARCH_CENTER_MAP_DATA: string[] = [
    '1111111111111111111111111111111111111111111111111111111',
    '1100001100000000022120000211000000000000000000000000001',
    '1000000100010001000100000010000222000000011100000001111',
    '1001111100010001000122220010002222200000111110000011111',
    '1001111100010001000122220010002222200000111110000011111',
    '1000010100010001000100200010000222000000011100000000011',
    '1000010100010001000100200010000222000000011100000000011',
    '1000010100010001000100200010000222000000011100000000011',
    '1000010100010001000100200010000000000000000000022220011',
    '1000000100000000000100000010000000000000000000022220001',
    '1111001111111111001111100111100011111111111111111111111',
    '1220000000000000000000000000000000000000000001000000011',
    '1220000000000000000000000000000000000000000000000000001',
    '1220000000000000000000000000000000000000000000002222001',
    '1220000000000000000000000000000000000000000001002222001',
    '1220000000000000000000000022200000000000000001002222001',
    '1220000000000000000000000022200000000000000001002222001',
    '1111111111100111110011111111111111111100000001002222001',
    '1000000000000001000002200000002212222200000001002222001',
    '1000000000000001220000000000002212222200000001002222001',
    '1000000000000001220000000000002212200000000001002222001',
    '1000000000000001220000000000002210000000000001002222001',
    '1000000000000001220002220000002210000020000001002222001',
    '1000000000000001220002220000002210022220000001002222001',
    '1000000000000001220002220000002212222220000001002002001',
    '1000000000000001220002220000002212222220000001000000201',
    '1000000000000001220002220000002210000000000001000000201',
    '1000000000000001200002220000000010000000000001000000001',
    '1111111111111111111111111111111111111110000111111111111',
];
